import React, { useState } from 'react';
import Modal from '../UI/Modal';

interface ManageStrategiesModalProps {
  isOpen: boolean;
  onClose: () => void;
  strategies: { [key: string]: string }; // name -> compressed state
  onLoadStrategy: (stateData: string) => void;
  onDeleteStrategy: (name: string) => void;
}

const ManageStrategiesModal: React.FC<ManageStrategiesModalProps> = ({
  isOpen,
  onClose,
  strategies,
  onLoadStrategy,
  onDeleteStrategy
}) => {
  const [confirmLoad, setConfirmLoad] = useState<string | null>(null);
  const [confirmDelete, setConfirmDelete] = useState<string | null>(null);
  
  const handleLoad = (name: string) => {
    if (confirmLoad === name) {
      // User has confirmed, load the strategy
      onLoadStrategy(strategies[name]);
      setConfirmLoad(null);
      onClose();
    } else {
      // Ask for confirmation
      setConfirmLoad(name);
      setConfirmDelete(null);
    }
  };
  
  const handleDelete = (name: string) => {
    if (confirmDelete === name) {
      // User has confirmed, delete the strategy
      onDeleteStrategy(name);
      setConfirmDelete(null);
    } else {
      // Ask for confirmation
      setConfirmDelete(name);
      setConfirmLoad(null);
    }
  };
  
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="My Strategies" customWidth="max-w-2xl">
      <div className="space-y-4">
        <div className="bg-yellow-800 text-yellow-100 p-3 rounded text-sm mb-4">
          <p><strong>Warning:</strong> Loading a strategy will overwrite your current setup, including idols and atlas device settings. Save your current setup first to not lose any progress.</p>
        </div>
        
        {Object.keys(strategies).length === 0 ? (
          <p className="text-gray-400 text-center py-4">No saved strategies yet.</p>
        ) : (
          <div className="space-y-2 max-h-96 overflow-y-auto pr-2 custom-scrollbar">
            {Object.keys(strategies).map((name) => (
              <div key={name} className="flex justify-between items-center bg-gray-700 p-3 rounded">
                <div className="flex-1 mr-4 overflow-hidden">
                  <h3 className="font-medium truncate">{name}</h3>
                </div>
                <div className="flex space-x-2">
                  <button
                    onClick={() => handleLoad(name)}
                    className={`px-3 py-1 rounded text-sm ${
                      confirmLoad === name
                        ? 'bg-yellow-600 hover:bg-yellow-500'
                        : 'bg-blue-600 hover:bg-blue-500'
                    }`}
                  >
                    {confirmLoad === name ? 'Confirm Load' : 'Load'}
                  </button>
                  <button
                    onClick={() => handleDelete(name)}
                    className={`px-3 py-1 rounded text-sm ${
                      confirmDelete === name
                        ? 'bg-red-600 hover:bg-red-500'
                        : 'bg-gray-600 hover:bg-gray-500'
                    }`}
                  >
                    {confirmDelete === name ? 'Confirm' : '×'}
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ManageStrategiesModal;